import React from 'react'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box';
import {makeStyles} from '@mui/styles';
import {Grid,Typography,Button} from '@mui/material';
import Link from '@mui/material/Link';
//https://mail.google.com/mail/?view=cm&fs=1&to=suprithhattikal461@gmail.com
const useStyles= makeStyles(theme=>({
   
    emailContainer:{
         position:'fixed',
         right:0,
         display:'flex',
         flexDirection:'column',
         alignItems:'center',
         bottom:0,
         width:'60px'
 
    },
    divider:{
        color:'black',
        height:'150px'
        
     },
     email:{
         transform:'rotate(90deg)',
         color:'#a8b2d1',
         '&:hover':{
             color:'#64ffda'
         },
         textDecorationStyle:null
     }
 }))

const EmailContainer = () => {
    const classes = useStyles()
    return (
        <div>
                <Box className={classes.emailContainer}>
                    <Link target="_blank" style={{textDecoration:'none'}} href={"https://mail.google.com/mail/?view=cm&fs=1&to=suprithhattikal461@gmail.com"}><Typography className={classes.email} style={{marginBottom:'100px'}}>suprithhattikal461@gmail.com</Typography></Link>
                    <Divider orientation="vertical"  style={{color:'white',height:'150px',backgroundColor:'white',display:'flex'}}/>
                </Box>
            
        </div>
    )
}

export default EmailContainer
